module.exports = __webpack_public_path__ + "static/img/2.270fd92.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/atlas/TheMolding/2.jpg
// module id = 30eh
// module chunks = 1